import { useEffect, useState } from "react";
import { DataCollectionApi } from "../Api/api.DataCollection";
import { message } from "antd";
import { IUseDataCollectionOCRProps } from "../apps/Sections/DataCollection/IDataCollection";

const useDataCollectionOCR = (props: IUseDataCollectionOCRProps) => {
  const { onChangeInvestor } = props;
  const [isOcrLoading, setIsOcrLoading] = useState<any>({});
  const [token, setToken] = useState<string>("");

  const ocrFields = [
    "dateOfExpiration",
    "documentNumber",
    "dateOfBirth",
  ];

  useEffect(() => {
    const getToken = async () => {
      const response = await DataCollectionApi.getOcrToken();
      if (response?.data) {
        setToken(response.data);
      }
    };
    getToken();
  }, []);

  const updateInvestorFromOCR = (
    ocrObject: any,
    ocrFields: string[],
    arrayField: string | undefined,
    index: number | undefined
  ) => {
    ocrFields.forEach((field) => {
      const pascalCaseField = field.charAt(0).toUpperCase() + field.slice(1);
      if (ocrObject[pascalCaseField]) {
        const value = ocrObject[pascalCaseField];
        if (field.includes("date") && value?.valueDate) {
          onChangeInvestor(value?.valueDate, field, index, arrayField);
        } else if (value?.valueString) {
          onChangeInvestor(value?.valueString, field, index, arrayField);
        }
      }
    });
  };

  const handleBeforeUpload = async (
    file: File,
    shouldOcr: boolean,
    field: string,
    index?: number,
    arrayField?: string
  ) => {
    // 🔥 1. Subir archivo a tu API
    try {
      if (shouldOcr) {
        setIsOcrLoading((prev: any) => ({
          ...prev,
          [`${arrayField}_${index}`]: true,
        }));
      }

	  //check file size and format
	  if (file.size > 10 * 1024 * 1024) { // 10MB limit
		message.error("File size exceeds the limit of 10MB");
		setIsOcrLoading((prev: any) => ({
		  ...prev,
		  [`${arrayField}_${index}`]: false,
		}));
		return false;
	  }
	  if (!["image/png", "image/jpeg", "application/pdf"].includes(file.type)) {
		message.error("Invalid file format. Only PNG, JPEG, and PDF are allowed.");
		setIsOcrLoading((prev: any) => ({
		  ...prev,
		  [`${arrayField}_${index}`]: false,
		}));
		return false;
	  }

      const uploadResponse = await DataCollectionApi.uploadTemporaryFile(file);

      if (!uploadResponse?.data) {
        message.error("Error uploading file");
        setIsOcrLoading((prev: any) => ({
          ...prev,
          [`${arrayField}_${index}`]: false,
        }));
        return;
      }

      const fileUrl = uploadResponse.data;

      // ✅ 2. Guardar la URL en el inversor
      if (typeof onChangeInvestor === "function") {
        onChangeInvestor(fileUrl, field, index, arrayField);
      }

      // ✅ 3. Si hay que hacer OCR, procesar
      if (shouldOcr) {
        const ocrResponse = await DataCollectionApi.extractDataFromDocument(
          token,
          fileUrl
        );

        if (ocrResponse) {
          const ocrData = ocrResponse[0]?.cleanedData;
          if (ocrData) {
            updateInvestorFromOCR(ocrData, ocrFields, arrayField, index);
          }
        }
      }

      message.success("File uploaded successfully");
    } catch (error) {
      console.error("Error uploading or processing file", error);
      message.error("Error uploading or processing file");
	  return false;
    } finally {
      setIsOcrLoading((prev: any) => ({
        ...prev,
        [`${arrayField}_${index}`]: false,
      }));
    }

    return false;
  };
  return { isOcrLoading, handleBeforeUpload };
};

export default useDataCollectionOCR;
